import { useMyCollection } from "@/hooks/useCollection";
import useTranslation from "@/hooks/useTranslation";
import { cartSelectedIdsState } from "@/stores/cart";
import { ListItemAvatar } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AddIcon from "@material-ui/icons/Add";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import Pagination from "@material-ui/lab/Pagination";
import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import CreateCollectionDialog from "../../../../CreateCollectionCard/components/CreateCollectionDialog";
import ConfirmDialog from "./ConfirmDialog";

interface IProps {
  handleUpperClose?: () => void;
}

const CartList: React.FC<IProps> = ({ handleUpperClose }) => {
  const {
    getMyCollection,
    myCollection,
    loading,
    count,
    take: size,
    refetch,
  } = useMyCollection();

  const [page, setPage] = useState(1);

  useEffect(() => {
    getMyCollection((page - 1) * size);
  }, [page]);

  const { t } = useTranslation("bundle");

  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => setOpen(false);

  const refresh = async () => {
    await refetch((page - 1) * size);
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const ids = useRecoilValue(cartSelectedIdsState);

  const [_open, _setOpen] = useState(false);

  const _handleClickOpen = () => {
    _setOpen(true);
  };

  const _handleClose = () => {
    _setOpen(false);
  };

  const [collectionId, setCollectionId] = useState("");
  const [collectionName, setCollectionName] = useState("");

  return (
    <Spin spinning={loading}>
      <List>
        {myCollection?.map(({ id, name }) => (
          <ListItem
            button
            onClick={() => {
              setCollectionId(id);
              setCollectionName(name);
              _handleClickOpen();
            }}
            key={id}
          >
            <ListItemAvatar>
              <PlaylistAddCheckIcon />
            </ListItemAvatar>
            <ListItemText primary={name} />
          </ListItem>
        ))}
        <ListItem button onClick={() => setOpen(true)}>
          <ListItemAvatar>
            <AddIcon />
          </ListItemAvatar>
          <ListItemText primary={t("collection.create.itself")} />
        </ListItem>
        <ListItem>
          <Pagination
            count={Math.ceil(count / size)}
            shape="rounded"
            page={page}
            onChange={handleChange}
          />
        </ListItem>
      </List>
      <CreateCollectionDialog
        open={open}
        handleClose={handleClose}
        refresh={refresh}
      />
      <ConfirmDialog
        collectionName={collectionName}
        handleClose={_handleClose}
        open={_open}
        collectionId={collectionId}
        ids={ids}
        handleUpperClose={handleUpperClose}
      />
    </Spin>
  );
};

export default CartList;
